export default __webpack_public_path__ + "d68d87a06113a8d7db3fa34476aca01a.svg";